import { computed } from "vue";

export const useAvatarUser = (props) => {
  // Bounded presentations must supply any display name or avatar inline. A UID
  // is an attribution/fallback key, never permission to read a raw user row.
  return computed(() =>
    props.user || (props.userUid ? { uid: props.userUid } : null),
  );
};
